import { render, staticRenderFns } from "./gaia48-people.vue?vue&type=template&id=bc95295a&scoped=true&"
import script from "./gaia48-people.vue?vue&type=script&lang=js&"
export * from "./gaia48-people.vue?vue&type=script&lang=js&"
import style0 from "./gaia48-people.vue?vue&type=style&index=0&id=bc95295a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc95295a",
  null
  
)

export default component.exports